module.exports = __webpack_public_path__ + "img/icon-compte-light-green.3f11be8c.svg";